<template>
	<Popup :thisComponent="getPopup" @close="showPopup(null)" :show="getPopup !== null" :hasClose="getPopupHasClose" />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Popup from '@/components/Popup';

export default {
	components: {
		Popup,
	},
	async mounted() {
		if (!this.isLoggedIn) {
			await this.fetchCurrentUser();
		}
	},
	computed: {
		...mapGetters('auth', ['isLoggedIn']),
		...mapGetters(['getPopup', 'getPopupHasClose']),
	},
	methods: {
		...mapActions('auth', ['fetchCurrentUser']),
		...mapMutations(['showPopup']),
	},
};
</script>
